/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityMuteNotificationResponse } from './MonitEntityMuteNotificationResponse';
import {
    MonitEntityMuteNotificationResponseFromJSON,
    MonitEntityMuteNotificationResponseFromJSONTyped,
    MonitEntityMuteNotificationResponseToJSON,
} from './MonitEntityMuteNotificationResponse';

/**
 * 
 * @export
 * @interface MonitPaginatedEntityMuteNotificationsResponse
 */
export interface MonitPaginatedEntityMuteNotificationsResponse {
    /**
     * 
     * @type {Array<MonitEntityMuteNotificationResponse>}
     * @memberof MonitPaginatedEntityMuteNotificationsResponse
     */
    results?: Array<MonitEntityMuteNotificationResponse>;
}

/**
 * Check if a given object implements the MonitPaginatedEntityMuteNotificationsResponse interface.
 */
export function instanceOfMonitPaginatedEntityMuteNotificationsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitPaginatedEntityMuteNotificationsResponseFromJSON(json: any): MonitPaginatedEntityMuteNotificationsResponse {
    return MonitPaginatedEntityMuteNotificationsResponseFromJSONTyped(json, false);
}

export function MonitPaginatedEntityMuteNotificationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPaginatedEntityMuteNotificationsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(MonitEntityMuteNotificationResponseFromJSON)),
    };
}

export function MonitPaginatedEntityMuteNotificationsResponseToJSON(value?: MonitPaginatedEntityMuteNotificationsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(MonitEntityMuteNotificationResponseToJSON)),
    };
}

